import { useEffect } from 'react';
import { useField } from './useField';

export const useIsMobile = (breakpoint = 768) => {
  const isMobile = useField(false);

  useEffect(() => {
    const handleResize = () => {
      isMobile.setValue(window.innerWidth < breakpoint);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return { isMobile };
};
